module.exports = __webpack_public_path__ + "Flama-BoldItalic.ttf?f8e3154ef30932ba1d436579b1b57a75";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-BoldItalic.ttf
// module id = 913
// module chunks = 0